export default {
  isSelfSubmitted: [
    'required',
    {
      isValid: input => (
        input || 'The custom field is not valid'
      ),
    },
  ],
  hasApplicationConsented: [
    'required',
    {
      isValid: input => (
        input || 'The custom field is not valid'
      ),
    },
  ],

  'applicant.firstName': ['required'],
  'applicant.lastName': ['required'],
  'applicant.email': [
    'required',
    {
      rule: 'email',
      isValid: (input) => {
        const blokingEmails = [
          'none@none.com',
          'noemail@noemail.com',
          'noemail@gmail.com',
          'Noemail@email.com',
          'NONE@NOEMAIL.COM',
          'none@gmail.com',
          'none@yahoo.com',
          'no@no.com',
          'no@email.com',
          'noemail@yahoo.com',
          'test@test.com',
          'NA@NA.COM',
          'noname@gmail.com',
          'no@gmail.com',
          'noemail@mail.com',
          'test@email.com',
          'unknown@yahoo.com',
          'non@non.com',
          'NOEMAL@NOEMAIL.COM',
          'none@email.com',
          'noname@email.com',
          'noemail@no.com',
          'NON@NONE.COM',
          'EMAIL@EMAIL.COM',
          'nomail@gmail.com',
          'NOEMAIL@GIMAIL.COM',
          'NOEMAIL@AOL.COM',
          'na@gmail.com',
          'noemail@gmai.com',
          'Noemail@noemai.com',
          'none@aol.com',
        ];

        return blokingEmails.includes(input) ? 'Phone number is fake' : true;
      },
    },
  ],
  'applicant.ssn': ['required'],
  'applicant.dateOfBirth': ['required'],
  'applicant.addresses.address1': ['required'],
  'applicant.addresses.city': ['required'],
  'applicant.addresses.state': ['required'],
  'applicant.addresses.zipcode': ['required'],

  'applicant.phoneNumbers.Number': [{
    rule: 'required',
    isValid: (input) => {
      const phoneNumbers = [
        '(111) 111-1111',
        '(222) 222-2222',
        '(333) 333-3333',
        '(444) 444-4444',
        '(555) 555-5555',
        '(666) 666-6666',
        '(777) 777-7777',
        '(999) 999-9999',
      ];

      return (
        phoneNumbers.includes(input) ||
        input.charAt(1) === '0' ||
        input.charAt(1) === '1' ||
        input.substring(6) === '000-0000'
      ) ? 'Phone number is fake' : true;
    },
  }],

  'financials.stated.employmentStatus': ['required'],
  'financials.stated.employerName': ['required'],
  'financials.stated.employerPhone': ['required'],
  'financials.stated.employmentYears': ['required'],
  'financials.stated.grossMonthlyIncome': ['required'],
  'financials.stated.monthlyRentOrMortage': ['required'],
  'financials.stated.rentOrOwn': ['required'],
  'signatureBy.name': ['required'],
};



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/Application/schema.js